import SupportService from './support';

export default SupportService;
